/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DistributionJobResponse } from '../../models/distribution-job-response';

export interface GetJobsForRule$Params {
  'Active-Tenant-Identifier': string;
  ruleId: string;
}

export function getJobsForRule(http: HttpClient, rootUrl: string, params: GetJobsForRule$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DistributionJobResponse>>> {
  const rb = new RequestBuilder(rootUrl, getJobsForRule.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('ruleId', params.ruleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DistributionJobResponse>>;
    })
  );
}

getJobsForRule.PATH = '/distribution-rules/{ruleId}/jobs';
